// extracted by mini-css-extract-plugin
module.exports = {"footerLogin":"Footer_footerLogin__1bRXZ","footer":"Footer_footer__7dIj9","footerLabel":"Footer_footerLabel__2EqvQ"};